import { Typography } from 'antd';
import React from 'react';
import { LiteLayout } from '@/presentation/layouts/lite';
import { SecurityForm } from '@/presentation/pages/security/form';
import styles from './index.module.scss';

const { Title } = Typography;

const SecurityPage = () => (
    <LiteLayout showAvatar={false}>
      <div className={styles.securityPage}>
        <Title level={4} className={styles.title}>完善账号信息</Title>
        <SecurityForm />
      </div>
    </LiteLayout>
);

export default SecurityPage;
